export default {
  "base": "relative grid sm:grid-cols-2 lg:grid-cols-3 gap-8"
}